// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1h3ZI","requiredAsterisk":"Info_requiredAsterisk__2WhSD"};